import {createFileRoute} from '@tanstack/react-router';
import FeedbackConfigPage from '../../../../pages/FeedbackConfigPage';

export const Route = createFileRoute(
  '/_authenticated/courses/$courseId/feedback-config',
)({
  component: function CourseFeedbackConfigRoute() {
    const {courseId} = Route.useParams();
    return <FeedbackConfigPage courseId={courseId} />;
  },
});
